import { AspectRatio, Card, StandardTileImage, Column, GridContainer, Row } from '@vp/swan'

export const LoadingClusterTiles = () => {
  return (
    <GridContainer mb={5}>
      <Row>
        {Array.from({ length: 3 }).map((_, index) => (
          <Column key={index} span={4}>
            <Card>
              <StandardTileImage>
                <AspectRatio
                  ratio={0.5}
                  loadingShimmer
                  data-testid='aspect-ratio-shimmer'
                />
              </StandardTileImage>
            </Card>
          </Column>
        ))}
      </Row>
    </GridContainer>
  )
}
